// extracted by mini-css-extract-plugin
export default {"container":"Warnings_container__KR9RP","info":"Warnings_info__73Ev7"};